import superagent from "superagent";

import { API_PREFIX } from "app/constants";
import to from "core/util/fetch/awaitToJs";

const getUriPrefix = (idObject: string) => `${API_PREFIX}/contract/${idObject}/change-sheet-record`;

const getChangeSheetRecord = async (idObject: string, changeSheetId: string) => {
    return await to(superagent.get(`${getUriPrefix(idObject)}/${changeSheetId}`));
};

const cancelChangeSheetRecord = async (idObject: string, changeSheetId: string) => {
    return await to(superagent.delete(`${getUriPrefix(idObject)}/${changeSheetId}`));
};

export default {
    getChangeSheetRecord,
    cancelChangeSheetRecord,
};
